import ChallengeHistoryItem from './ChallengeHistoryItem';

export default ChallengeHistoryItem;
